import { useEffect, useState } from "react";
import api from "../utils/axios";

export function useOrderEligibility(labId, enabled = true) {
  const [eligibility, setEligibility] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState(null);

  const fetchEligibility = async () => {
    if (!enabled) {
      setEligibility(null);
      setError(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const { data } = await api.get("/users/me/order-eligibility", {
        params: labId ? { labId } : undefined,
      });

      setEligibility(data);
    } catch (requestError) {
      const message =
        requestError?.response?.data?.message ||
        requestError?.message ||
        "Error al consultar la elegibilidad de pedido";

      setEligibility(null);
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!enabled) {
      setEligibility(null);
      setError(null);
      setLoading(false);
      return;
    }

    fetchEligibility();
  }, [labId, enabled]);

  return {
    eligibility,
    loading,
    error,
    refetch: fetchEligibility,
  };
}
